import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import RatingComponent from "../../components/RatingComponent";
import { setAddFields } from "../../store/slice/feedback.slice";
import { useSelector } from "react-redux";
import { hoekMaat } from "../../lib/hoek";

const QuestionAnswerComponent = ({ data, Css }) => {
  const { basicLanguages } = useSelector((s) => s.feedback);

  return (
    <Box
      sx={{
        height: "100%",
        borderRadius: hoekMaat(14),
        border: `1px solid ${Css?.QuestionCardBorderClr || "rgba(0,0,0,0.08)"}`,
        backgroundColor: Css?.QuestionCardBgClr || "#fafafa",
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        transition: "box-shadow 0.2s",
        "&:hover": { boxShadow: "0 4px 18px rgba(0,0,0,0.07)" },
      }}
    >
      {/* Question label */}
      <Box>
        {data?.required && (
          <Chip
            label={basicLanguages?.required ?? "Required"}
            size="small"
            sx={{
              mb: 1,
              height: 20,
              fontSize: "10px",
              fontWeight: 600,
              backgroundColor: "rgba(243,113,32,0.1)",
              color: "#f37120",
              borderRadius: hoekMaat(6),
            }}
          />
        )}
        <Typography
          sx={{
            color: Css?.QuestionClr || "#111827",
            fontSize: { xs: "15px", md: "17px" },
            fontWeight: 600,
            lineHeight: 1.4,
          }}
        >
          {data?.name}
        </Typography>
        {data?.info && (
          <Typography
            sx={{
              color: Css?.feedbackInfoClr || "#6b7280",
              fontSize: { xs: "12px", md: "13px" },
              mt: 0.5,
              lineHeight: 1.6,
            }}
          >
            {data?.info}
          </Typography>
        )}
      </Box>

      {/* Rating */}
      <Box sx={{ mt: "auto" }}>
        <RatingComponent
          data={data}
          name={data?.name?.replace(/\s+/g, "")}
          setField={setAddFields}
          Css={Css}
        />
      </Box>
    </Box>
  );
};

export default QuestionAnswerComponent;
